export default __webpack_public_path__ + "static/media/Quadified_N_H.4d549172.png";